import { navigate } from 'gatsby'
import React, { useEffect } from 'react'
import * as Styles from './index.module.scss'
import { DownloadPageTitle } from '@/components/contact/download-page-title'
import { ServiceDocumentContainer } from '@/components/contact/service-document-container'
import { DownloadForm } from '@/components/form/download-form'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'
import { pagesPath } from '@/lib/pagesPath'
import { useFormStorage } from '@/lib/use-form-storage'

const DownloadPage = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage()
  const formState = getFormStorage()

  useEffect(() => {
    if (formState) {
      return () => cleanFormStorage()
    }
  }, [])
  return (
    <Layout location={location}>
      <Seo
        title="資料請求"
        description="クラウド決算開示管理サービス【Uniforce】のサービス資料はこちらからダウンロードが可能です。"
      />
      <DownloadPageTitle
        title="資料請求"
        en="DOWNLOAD"
        readText="サービス概要・機能説明資料"
      />

      <div className={Styles.container}>
        <DownloadForm
          className={Styles.form}
          initFormState={{
            ...formState,
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state)
            await navigate(pagesPath.download.confirmation.$url())
          }}
        />

        <ServiceDocumentContainer />
      </div>
    </Layout>
  )
}

export default DownloadPage
